export default __webpack_public_path__ + "static/map-09cbcba585702e58f5a92df95e8c700f.png";